import { useTranslation } from 'react-i18next';

export const keyPrefix = 'color_picker';
export const useColorPickerTranslation = () => useTranslation('shared', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    color: 'Цвет',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    color: 'Color',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    color: 'Cor',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    color: 'Color',
  },
}) : {}) as Record<string, unknown>;
